import React from 'react';
import StartPage from '../PAGES/StartPage';
import GamePage from '../PAGES/GamePage';
import { START_PAGE, GAME_PAGE } from '../../HOME/const';
import { connect } from 'react-redux';
import { goToPage } from '../../HOME/REDUX/actions';

const Numerica = props => {
  let page = props.page;

  if (!page) {
    props.goToPage((page = START_PAGE));
  }

  return (
    <>
      {page === START_PAGE ? <StartPage /> : null}
      {page === GAME_PAGE ? <GamePage /> : null}
    </>
  );
};

function mapStateToProps({ nm, common }) {
  return { ...nm, ...common };
}

export default connect(
  mapStateToProps,
  { goToPage }
)(Numerica);
